interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const VisaIcon = ({
  size = 55,
  width,
  height,
  fill = "white",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size * (18 / 55)}
      viewBox="0 0 55 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50.4863 17.5606L49.9751 15.0047H44.2636L43.3548 17.5424L38.7769 17.5515C41.719 10.4791 43.9046 5.24232 45.3291 1.83674C45.7017 0.946148 46.3628 0.491767 47.3375 0.498583C48.0826 0.505399 49.2981 0.505397 50.9861 0.500854L54.5258 17.5538L50.4863 17.5606ZM45.5472 11.5037H49.23L47.8554 5.09692L45.5472 11.5037ZM16.0442 0.49631L20.6471 0.500854L13.5315 17.5629L8.8718 17.5583C7.70006 13.0516 6.5429 8.54107 5.40032 4.02685C5.17313 3.12718 4.72329 2.49786 3.8577 2.20024C2.57757 1.77265 1.29154 1.36291 0 0.971138L0 0.500854H7.35416C8.62643 0.500854 9.36934 1.11654 9.60789 2.37972C9.84872 3.64517 10.453 6.86901 11.4254 12.0444L16.0442 0.49631ZM26.9721 0.500854L23.3348 17.5606L18.9522 17.5538L22.5828 0.49631L26.9721 0.500854ZM35.8552 0.185059C37.1661 0.185059 38.8178 0.594001 39.7675 0.971138L38.9996 4.50623C38.1408 4.1609 36.7276 3.69516 35.5394 3.71106C33.8128 3.74059 32.745 4.46533 32.745 5.16054C32.745 6.29195 34.5989 6.86219 36.5073 8.09811C38.6838 9.50669 38.9723 10.7721 38.945 12.1489C38.9155 15.0002 36.5073 17.8151 31.4273 17.8151C29.1099 17.781 28.2739 17.5879 26.3837 16.9154L27.1834 13.2258C29.1077 14.0301 29.9233 14.2868 31.5681 14.2868C33.0744 14.2868 34.3671 13.6779 34.3785 12.6169C34.3876 11.8627 33.9241 11.4878 32.2338 10.5563C30.5435 9.62256 28.1716 8.33212 28.2035 5.73533C28.2421 2.4138 31.3887 0.185059 35.8552 0.185059Z"
        fill={fill}
      />
    </svg>
  );
};

export default VisaIcon;
